<template>
   <div class="rd-navbar-basket-wrap">
      <button class="rd-navbar-basket fl-bigmug-line-shopping202" data-rd-navbar-toggle=".cart-inline"><span>{{ cartItemCount }}</span></button>
      <div class="cart-inline">
         <div v-if="cart.length > 0" class="cart-inline-header">
            <h5 class="cart-inline-title">In cart:<span> {{ cartItemCount }}</span> Products</h5>
            <h6 class="cart-inline-title">Total price:<span> ${{ subtotal }}</span></h6>
         </div>
         <div v-if="cart.length > 0" class="cart-inline-body">
            <div v-for="item in cart" :key="item.id" class="cart-inline-item">
               <div class="unit unit-spacing-sm align-items-center">
                  <div class="unit-left"><router-link class="cart-inline-figure" :to="item.slug"><img :src="item.image || '/assets/images/dummy_100_90.webp'" onerror="this.onerror=null;this.src='/assets/images/dummy_100_90.webp';" :alt="item.name" width="100" height="90"/></router-link></div>
                  <div class="unit-body">
                    <h6 class="cart-inline-name"><router-link :to="item.slug">{{ item.name }}</router-link></h6>
                    <div class="quantity d-flex align-items-center">
                      <button class="btn btn-outline-secondary qty-btn" @click="cartStore.updateQuantity(item.product_sku_id, item.quantity - 1)">−</button>
                      <input type="text" class="form-control qty-input" :value="item.quantity" readonly>
                      <button class="btn btn-outline-secondary qty-btn" @click="cartStore.updateQuantity(item.product_sku_id, item.quantity + 1)">+</button>
                      <span class="price ms-2">${{ item.price }}</span>
                    </div>
                  </div>
               </div>
            </div>            
         </div>
         <div v-else class="cart-inline-body">
            <h6 class="text-center">Your cart is empty</h6>
         </div>
         <div v-if="cart.length > 0" class="cart-inline-footer">
            <div class="group-sm"><a class="button button-default-outline-2 button-zakaria" href="/cart">Go to cart</a><a class="button button-primary button-zakaria" href="/checkout">Checkout</a></div>
         </div>
      </div>
   </div>
   <a class="rd-navbar-basket rd-navbar-basket-mobile fl-bigmug-line-shopping202 rd-navbar-fixed-element-2" href="/cart"><span>{{ cartItemCount }}</span></a>
</template>
<script setup>
import { useCartStore } from '@/stores/cart'
import { storeToRefs } from 'pinia'

const cartStore = useCartStore()
const { cart, subtotal, cartItemCount } = storeToRefs(cartStore)

</script>
